module.exports = __webpack_public_path__ + "img/15.15b6448a.jpg";